import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {FeatureEventData, slotStore} from '../../globals';
import {AutoplayOptions, PartialAutoplayOptions, SlotSettings} from '@gongxigames/framework/slot';
import {listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class DisabledUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.on('Game.command.round.featureStopped', () => {
            slotStore.batchUpdate({feature_type: null});
            // @Igor TODO why there is no this.onExecuted?.(); here?
        });
        this.emitter.on('Game.command.round.featureStarted', (data: FeatureEventData) => {
            slotStore.batchUpdate({
                feature_type: data
            });

            this.removeAllListeners();
            slotStore.isDisabledUIMode.value = false;
            this.onExecuted?.();
        });

        this.emitter.on('UI.command.autoplay.changedOption', this.onChangedAutoplayOption.bind(this));
        this.emitter.on('UI.command.startAutoplay', (options: AutoplayOptions) => {
            this.startAutoplay(options);
            slotStore.isDisabledUIMode.value = false;
            this.onExecuted?.();
        });

        listenUIDisabled(this);

        this.emitter.on('Game.command.round.uiEnabled', () => {
            slotStore.isDisabledUIMode.value = false;
            this.onExecuted?.();
        });
    }

    protected startAutoplay(options: AutoplayOptions): void {
        slotStore.batchUpdate({
            isAutoplay: true,
            autoplayOptions: options,
        });
    }

    protected onChangedAutoplayOption(options: PartialAutoplayOptions): void {
        if (options.autoplaySpins !== undefined && options.autoplaySpins !== null) {
            const autoplayValues = (this.settings as SlotSettings).get('autoplayValues');

            (this.settings as SlotSettings).set('autoplayDefaultSelectedSpins', autoplayValues.indexOf(options.autoplaySpins));
        }
    }

    getName(): string {
        return 'DisabledUIAct';
    }
}